import { FC } from 'react'
import Link from 'next/link'
import Head from 'next/head'

import MainLayout from 'containers/main-layout/main-layout'

import { PROMO_REDIRECT_URL } from 'constants/data'

import styles from 'styles/webinar/webinar-norec.module.scss'

const PageNoRecord: FC = () => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <MainLayout noFooter>
        <div className={styles.container}>
          <div className={styles.textWrapper}>
            <h2 className={styles.text}>
              Данный вебинар был без записи. К сожалению, лекция для просмотра недоступна 🙁
            </h2>
            <Link href={PROMO_REDIRECT_URL} className={styles.link}>
              Вернуться на главную
            </Link>
          </div>
        </div>
      </MainLayout>
    </>
  )
}

export default PageNoRecord
